import { FieldRenderProps } from "@progress/kendo-react-form";
import { Input } from "@progress/kendo-react-inputs";
import { Error } from "@progress/kendo-react-labels";

export const EmailInputWithValidation = (fieldRenderProps: FieldRenderProps) => {
    //@ts-ignore
    const { validationMessage, visited, ...others } = fieldRenderProps;
  
    return (
      <div className="k-form-field-wrap">
        <Input {...others} labelClassName={"k-form-label"} />
        {visited && validationMessage && <Error>{validationMessage}</Error>}
      </div>
    );
  };
  